import service from '@/service'

/**
 * @description 对接处理结果查询
 */
export function getList(data) {
  return service['api-scm']({
    url: '/cloudWarehouse/callback/getList',
    method: 'post',
    data
  })
}
